import { Col, Container, Row } from "react-bootstrap";
import "devextreme/data/odata/store";
import DataGrid, { Column, Paging, Export, FilterRow, HeaderFilter, SearchPanel } from "devextreme-react/data-grid";
import React, { useEffect, useState } from "react";
import { withStatisticWapper } from "../statistics";
import "./statisticDocument.scss";
import { DocumentService } from "../../../services/document/document.service";
import { CreateNotification } from "../../../components/notifier";
import { getDDMMYYYFormat, getUCTDate } from "../../../helper/dateTimeHelper";
import moment from "moment";

export const StatisticDocumentPage = withStatisticWapper(() => {
  const [documentInfo, setDocumentInfo] = useState<any>([]);

  const getDocumentInfo = async () => {
    DocumentService.getListDocumentInfo()
      .then((res) => {
        setDocumentInfo(res);
      })
      .catch((error) => {
        CreateNotification({
          title: "Thông báo",
          body: "Không đọc được thông tin tài liệu, vui lòng thử lại",
          icon: "/icons/error.png",
        });
        console.log(error);
      });
  };
  const documentStatusRender = (item: any) => {
    let today = new Date();
    return item.data.docStatusId === 8 && item.data.effectiveTo < getUCTDate(today) ? "Lỗi thời" : item.data.docStatus;
  };

  const handleRenderDataRow = (row: any) => {
    const today = new Date();
    let bgColor = "";
    if (row.data.docStatusId === 8 && row.data.effectiveTo < getUCTDate(today))
      bgColor = "py-2 px-2 bgColor_text-danger";
    else if (row.data.docStatusId === 5) bgColor = "py-2 px-2 bgColor_text-interpublish";
    else if (row.data.docStatusId === 8 && row.data.effectiveTo >= getUCTDate(today)) {
      bgColor = "py-2 px-2 bgColor_text-valid";
    } else bgColor = "py-2 px-2 bgColor_text-remaining";

    return (
      <tr className={bgColor}>
        <td>{row.data.id}</td>
        <td style={{ textAlign: "left" }}>{row.data.docCode}</td>
        <td style={{ textAlign: "left" }}>{row.data.Title}</td>
        <td style={{ textAlign: "left" }}>{row.data.docType}</td>
        <td style={{ textAlign: "left" }}>
          {row.data.docStatusId === 8 && moment(row.data?.effectiveTo).isSameOrBefore(moment())
            ? "Lỗi thời"
            : row.data.docStatus}
        </td>
        <td style={{ textAlign: "left" }}>{getDDMMYYYFormat(row.data.effectiveFrom)}</td>
        <td>{row.data.docPublishViewVersion}</td>
        <td>{row.data.docEditionVersion}</td>
        <td style={{ textAlign: "left" }}>{row.data.userDisplayName}</td>
        <td style={{ textAlign: "left" }}>{getDDMMYYYFormat(row.data.lastModifiedDateTime)}</td>
      </tr>
    );
  };

  useEffect(() => {
    getDocumentInfo();
  }, []);

  return (
    <>
      <Container fluid className="notify-page">
        <Row>
          <Col sm={12} md={12} className="py-3">
            <Col className="py-3 statistic-header">
              <h3>TÌNH TRẠNG TÀI LIỆU</h3>
              <p>
                <i>Thống kê tình trạng tài liệu: đang hiệu lực, đang soát xét, chờ phê duyệt, đã lỗi thời</i>
              </p>
            </Col>
            <Col className="d-flex flex-row-reverse bd-highlight">
              {/* <Button
                title={"Upload tài liệu"}
                className="btn mr-2"
                variant="outline-info"
              >
                <FontFa name="faUpload" size={"xs"} onclick={actionClick()} />
              </Button> */}
              {/* <Button
                title={"In tài liệu"}
                className="btn mr-2"
                variant="outline-info"
              >
                <FontFa name="faPrint" size={"xs"} />
              </Button> */}
              {/* <div className="search_filter mr-2">
                            <Icon.Search/>
                            <input placeholder="Tìm kiếm tài liệu" type="search" className="search_input-filter" />
                        </div> */}
            </Col>
            <Col className="py-2 grid__container">
              {documentInfo && (
                <DataGrid
                  id="grid_content"
                  noDataText="Không tìm thấy tài liệu"
                  dataSource={documentInfo.data}
                  showBorders={true}
                  allowColumnReordering={true}
                  showRowLines={true}
                  remoteOperations={true}
                  wordWrapEnabled={true}
                  dataRowRender={handleRenderDataRow}
                >
                  <SearchPanel visible={true} placeholder="Nhập tài liệu cần tìm" width={300} />
                  <FilterRow visible={true} applyFilter={true} />
                  <HeaderFilter visible={true} />
                  <Export enabled={true} />
                  <Column dataField="id" dataType="string" caption="ID" />
                  <Column dataField="docCode" dataType="number" caption="Mã tài liệu" />
                  <Column dataField="Title" dataType="string" caption="Tên tài liệu" cssClass="red" />
                  <Column dataField="docType" dataType="string" caption="Loại tài liệu" />
                  <Column
                    dataField="docStatus"
                    dataType="string"
                    cellRender={documentStatusRender}
                    caption="Tình trạng"
                  />
                  <Column
                    dataField="effectiveFrom"
                    dataType="date"
                    caption="Hiệu lực từ"
                    selectedFilterOperation="between"
                    allowHeaderFiltering={false}
                  />
                  <Column dataField="docPublishViewVersion" dataType="number" caption="Lần ban hành" />
                  <Column dataField="docEditionVersion" dataType="number" caption="Lần sửa đổi" />
                  <Column alignment="center" dataField="userDisplayName" dataType="string" caption="Người cập nhật" />
                  <Column
                    dataField="lastModifiedDateTime"
                    dataType="date"
                    caption="Ngày cập nhật gần nhất"
                    selectedFilterOperation="between"
                    allowHeaderFiltering={false}
                  />
                  {/* <Column
                    dataField="docLinks"
                    dataType="string"
                    caption="Tài liệu hướng dẫn"
                  /> */}
                  {/* <Column
                    dataField="docNotes"
                    dataType="string"
                    caption="Ghi chú"
                  /> */}
                  <Paging defaultPageSize={14} />
                </DataGrid>
              )}
            </Col>
            <Col className="ml-3 block_container">Note: Màu thể hiện tình trạng tài liệu</Col>
          </Col>
        </Row>
        <Row className="ml-3">
          <Col sm={12} md={3} className="py-2 d-flex block_container">
            <div className="block_text-1 mr-2"></div>
            <div>Tài liệu lỗi thời</div>
          </Col>
          <Col sm={12} md={3} className="py-2 d-flex block_container">
            <div className="bg-warning block_text-2 mr-2"></div>
            <div>Tài liệu thử nghiệm</div>
          </Col>
        </Row>
        <Row className="ml-3">
          <Col sm={12} md={3} className="py-2 d-flex block_container">
            <div className="bg-info block_text-3 mr-2"></div>
            <div>Tài liệu có hiệu lực</div>
          </Col>
          {/* <Col sm={12} md={3} className="py-2 d-flex block_container">
                <div className="block_text-4 mr-2"></div>
                <div>Tài liệu ban hành tạm thời</div>
              </Col> */}
        </Row>
      </Container>
    </>
  );
});
